import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { currentAdminQuery } from "@/api/queries";
import { safeRedirect } from "@/auth/session";
import { LoginPage } from "@/features/auth/login-page";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({ redirect: z.string().optional().catch(undefined), reason: z.enum(["expired"]).optional().catch(undefined) }),
  beforeLoad: async ({ context, search }) => {
    const current = await context.queryClient.ensureQueryData(currentAdminQuery());
    if (current) throw redirect({ href: safeRedirect(search.redirect) });
  },
  head: () => ({ meta: [{ title: "Sign in · Rogue Admin" }] }),
  component: LoginPage,
});
